import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Components
import CreateCustomer from './createCustomer';

// Hooks
import CustomerProvider from '../../../hooks/customers/CustomerProvider';

const CreateCustomerView = () => {
    const { customerId } = useParams();
    const navigate = useNavigate();

    const handlerSuccess = (customer) =>
        navigate('/customers');

    const handlerCancel = () =>
        navigate(-1);

    return (
        <CustomerProvider>
            <CreateCustomer
                customerId={customerId}
                onAccept={handlerSuccess}
                onCancel={handlerCancel}
            />
        </CustomerProvider>
    )
}

export default CreateCustomerView;